// Table column configuration interface
export interface TableColumn {
  title: string;
  key: string;
  minWidth: number;
  maxWidth: number;
  isClickable?: boolean;
}

// Table columns configuration for Agent Metrics Detail Table
export const agentMetricsColumns: TableColumn[] = [
  { title: "Agent / Queue", key: "displayName", minWidth: 140, maxWidth: 180 },
  { title: "Total handled calls", key: "totalHandledCalls", minWidth: 100, maxWidth: 120, isClickable: true },
  { title: "Transferred calls", key: "transferredCalls", minWidth: 120, maxWidth: 140 },
  { title: "Total answered duration", key: "totalAnsweredDuration", minWidth: 165, maxWidth: 185 },
  { title: "Average handle time", key: "averageHandleTime", minWidth: 135, maxWidth: 155 },
  { title: "Transferred rate (%)", key: "transferredRate", minWidth: 155, maxWidth: 175, isClickable: true },
  { title: "SLA (%)", key: "sla", minWidth: 110, maxWidth: 130, isClickable: true },
  { title: "Last call taken", key: "lastCallTakenSecond", minWidth: 135, maxWidth: 155 }
];